// A custom checkbox component that visually resembles a checkbox but behaves more like a button 
// Reason to use: Input type=checkbox doesn't seem to work with useNavigate for some reason - so this is replacement checkbox until we can figure out the underlying issue
// This component is used in ProcessMonitor and FileMonitor for the "Show Hidden" criteria

import React from "react";

export default function CSCheckbox({ name, label, checked, onChange }) {
  return (
    <button
      type="button"
      aria-pressed={checked}
      onClick={() =>
        onChange({
          target: {
            name: name,
            checked: !checked
          }
        })
      }
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 12px",
        border: "none", // No border around the button
        borderRadius: "4px",
        background: checked ? "#007bff" : "#fff",
        color: checked ? "#fff" : "#212529",
        cursor: "pointer",
        fontSize: "14px",
        minWidth: "80px"
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "24px", // Increased size
          height: "24px", // Increased size
          marginRight: "10px",
          border: "1px solid #bfbebe", // You may also remove this if you want no border on the checkbox visual
          borderRadius: "4px",
          background: "#fff", // Always white background
          position: "relative"
        }}
      >
        {checked && (
          <span
            style={{
              position: "absolute",
              left: "3px", // Move closer to top-left for larger check
              top: "-2px", // Move check mark higher relative to the box
              width: "15px", // Much larger check mark
              height: "20px", // Much larger check mark
              border: "solid #000", // Black check mark
              borderWidth: "0 6px 6px 0", // Thicker check mark
              transform: "rotate(45deg)",
              display: "block"
            }}
          />
        )}
      </span>
      {label}
    </button>
  );
}